'use strict';

var _ = require('lodash');
var DashboardPanelService = function DashboardPanelService(currentStateCriteriaService, searchCriteriaRsqlQueryService, momentService) {
  function getSearchQuery(type) {
    var rules = currentStateCriteriaService.getSearchCriteria().rules;
    if (type === 'FIM') {
      rules = _.reject(rules, function (rule) {
        return rule.searchContext === 'dashboard' && rule.criterion === 'POS' && rule.field === 'pointOfSales.posName';
      });
    }
    var query = searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules(rules);
    var date = momentService.now(momentService.FIELD.DASHBOARD_DATE);
    var fromMonth = date.month() + 1;
    var fromYear = date.year();
    var toDate = date.add(11, 'months');
    var toMonth = toDate.month() + 1;
    var toYear = toDate.year();
    if (query !== '') {
      query += ';';
    }
    if (fromYear !== toYear) {
      query = query + '((month=ge=' + fromMonth + ';month=le=12;year==' + fromYear + '),(month=ge=1;month=le=' + toMonth + ';year==' + toYear + '))';
    } else {
      query = query + '(month=ge=' + fromMonth + ';month=le=' + toMonth + ';year==' + fromYear + ')';
    }
    return query;
  }
  function getDashboardSearchQuery() {
    return getSearchQuery('DASHBOARD');
  }
  function getFimSearchQuery() {
    return getSearchQuery('FIM');
  }
  return {
    getDashboardSearchQuery: getDashboardSearchQuery,
    getFimSearchQuery: getFimSearchQuery
  };
};
DashboardPanelService.$inject = ['CurrentStateCriteriaService', 'SearchCriteriaRsqlQueryService', 'MomentService'];
module.exports = DashboardPanelService;